import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

pdfMake.vfs = pdfFonts;

function formatCurrency(value) {
  const val = parseFloat(value) || 0;
  return '$ ' + val.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function printReceiptPDF(transaccion, cuenta) {
  const win = window.open('', '_blank');
  
  try {
    const empresa = {
      razon_social: 'SARTINI GAS S.R.L.',
      cuit: '30-59748997-4',
      ing_brutos: '101926A',
      domicilio: 'Heroes de malvinas 4620',
      telefonos: ['(2901) 64-2929', '(2901) 61-6580'],
      localidad: 'Ushuaia - Tierra del Fuego',
      actividades: '01/01/1983',
      condicion_iva: 'IVA Responsable Inscripto'
    };

    const clientName = cuenta?.razon_social || transaccion.cliente || 'Consumidor Final';
    const clientDni = cuenta?.documento || 'S/D';
    const accountNumber = cuenta?.numero || 'S/D';
    const accountDesc = cuenta?.descripcion || 'S/D';

    // 1. Calcular Desglose de Pagos y Montos Ajustados
    const cambio = parseFloat(transaccion.cambio) || 0;
    const desglose = [];
    let totalPagoNeto = 0;

    if (transaccion.desglose_pagos && transaccion.desglose_pagos.length > 0) {
      // Caso Mixto
      transaccion.desglose_pagos.forEach(p => {
        const imp = parseFloat(p.importe) || 0;
        totalPagoNeto += imp;
        
        // Si es efectivo y hay cambio, sumamos el cambio para mostrar el entregado
        const isEfectivo = p.forma_pago.toUpperCase().includes('EFECTIVO') || p.forma_pago_id === 1;
        const importeMostrar = isEfectivo ? (imp + cambio) : imp;

        desglose.push({
          forma_pago: p.forma_pago,
          importe: importeMostrar
        });
      });
    } else {
      // Caso Tradicional de un solo pago
      const imp = parseFloat(transaccion.importe) || 0;
      totalPagoNeto = imp;
      
      const isEfectivo = (transaccion.transaccion_detalle && transaccion.transaccion_detalle.toUpperCase().includes('EFECTIVO')) || transaccion.forma_pago_id === 1;
      const importeMostrar = isEfectivo ? (imp + cambio) : imp;

      desglose.push({
        forma_pago: transaccion.transaccion_detalle || 'PAGO',
        importe: importeMostrar
      });
    }

    // 2. Definición del Documento pdfMake
    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 40, 40, 40],
      content: [
        // Encabezado de la Empresa (Estilo Premium)
        {
          columns: [
            {
              stack: [
                { text: empresa.razon_social, fontSize: 16, bold: true, color: '#311B92' },
                { text: 'Distribuidor Oficial Sartini Gas', fontSize: 10, italics: true, color: '#757575', margin: [0, 2, 0, 8] },
                { text: `Domicilio: ${empresa.domicilio}`, fontSize: 9, color: '#424242' },
                { text: `Localidad: ${empresa.localidad}`, fontSize: 9, color: '#424242' },
                { text: `Teléfono: ${empresa.telefonos.join(' / ')}`, fontSize: 9, color: '#424242' },
              ]
            },
            {
              stack: [
                { text: 'RECIBO DE PAGO', fontSize: 14, bold: true, alignment: 'right', color: '#1B5E20' },
                { text: `N°: ${transaccion.recibo_numero || 'S/N'}`, fontSize: 12, bold: true, alignment: 'right', margin: [0, 2, 0, 8] },
                { text: `Fecha: ${moment(transaccion.fecha).format('DD/MM/YYYY')}`, fontSize: 10, alignment: 'right', color: '#424242' },
                { text: `CUIT: ${empresa.cuit}`, fontSize: 9, alignment: 'right', color: '#424242' },
                { text: `Ing. Brutos: ${empresa.ing_brutos}`, fontSize: 9, alignment: 'right', color: '#424242' },
              ]
            }
          ]
        },
        
        { canvas: [{ type: 'line', x1: 0, y1: 10, x2: 515, y2: 10, lineWidth: 1.5, strokeColor: '#311B92' }] },
        
        // Datos del Cliente y de la Cuenta
        {
          margin: [0, 15, 0, 15],
          columns: [
            {
              width: '50%',
              stack: [
                { text: 'DATOS DEL CLIENTE', fontSize: 10, bold: true, color: '#311B92', margin: [0, 0, 0, 5] },
                { text: `Cliente: ${clientName}`, fontSize: 10, bold: true },
                { text: `DNI/CUIT: ${clientDni}`, fontSize: 9, color: '#424242', margin: [0, 3, 0, 0] }
              ]
            },
            {
              width: '50%',
              stack: [
                { text: 'DATOS DE LA CUENTA', fontSize: 10, bold: true, color: '#311B92', margin: [0, 0, 0, 5] },
                { text: `N° Cuenta: ${accountNumber}`, fontSize: 10, bold: true },
                { text: `Detalle: ${accountDesc}`, fontSize: 9, color: '#424242', margin: [0, 3, 0, 0] }
              ]
            }
          ]
        },
        
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, strokeColor: '#E0E0E0' }] },

        // Detalle de Formas de Pago
        { text: 'FORMAS DE PAGO:', fontSize: 11, bold: true, color: '#311B92', margin: [0, 15, 0, 10] },
        
        {
          table: {
            headerRows: 1,
            widths: ['*', 120],
            body: [
              // Header
              [
                { text: 'Método / Detalle', bold: true, fontSize: 10, color: '#FFFFFF', fillColor: '#311B92' },
                { text: 'Monto Entregado', bold: true, fontSize: 10, color: '#FFFFFF', fillColor: '#311B92', alignment: 'right' }
              ],
              // Items
              ...desglose.map(item => [
                { text: item.forma_pago, fontSize: 10, margin: [0, 5, 0, 5] },
                { text: formatCurrency(item.importe), fontSize: 10, alignment: 'right', margin: [0, 5, 0, 5] }
              ])
            ]
          },
          layout: {
            hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1 : 0.5,
            vLineWidth: () => 0,
            hLineColor: () => '#E0E0E0'
          }
        },

        // Totales y Cambio
        {
          margin: [0, 20, 0, 15],
          columns: [
            { text: '', width: '*' },
            {
              width: 220,
              stack: [
                {
                  columns: [
                    { text: 'TOTAL A PAGAR:', fontSize: 11, bold: true },
                    { text: formatCurrency(totalPagoNeto), fontSize: 11, bold: true, alignment: 'right' }
                  ],
                  margin: [0, 3, 0, 3]
                },
                { canvas: [{ type: 'line', x1: 0, y1: 3, x2: 220, y2: 3, lineWidth: 1, strokeColor: '#9E9E9E' }] },
                {
                  columns: [
                    { text: 'Total Pagado:', fontSize: 10, color: '#424242' },
                    { text: formatCurrency(totalPagoNeto), fontSize: 10, alignment: 'right', color: '#424242' }
                  ],
                  margin: [0, 5, 0, 2]
                },
                {
                  columns: [
                    { text: 'Su cambio:', fontSize: 10, bold: cambio > 0, color: cambio > 0 ? '#1B5E20' : '#424242' },
                    { text: formatCurrency(cambio), fontSize: 10, bold: cambio > 0, alignment: 'right', color: cambio > 0 ? '#1B5E20' : '#424242' }
                  ],
                  margin: [0, 2, 0, 5]
                }
              ]
            }
          ]
        },

        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, strokeColor: '#E0E0E0' }] },

        // Observaciones y Pie de Recibo
        {
          margin: [0, 15, 0, 0],
          stack: [
            { text: 'Observaciones / Glosa:', fontSize: 9, bold: true, color: '#757575', margin: [0, 0, 0, 3] },
            { text: transaccion.glosa || 'Sin observaciones adicionales.', fontSize: 9, color: '#424242', italics: true },
            { text: `Disponible en Cuenta: ${formatCurrency(transaccion.saldo)}`, fontSize: 10, bold: true, color: '#311B92', margin: [0, 12, 0, 0] }
          ]
        }
      ],
      footer: (currentPage, pageCount) => ({
        columns: [
          { text: `Operador: ${transaccion.autor || 'Sistema'}`, fontSize: 8, color: '#9E9E9E', margin: [40, 0, 0, 0] },
          { text: `Registrado: ${moment(transaccion.created_at).format('DD/MM/YYYY HH:mm')}`, fontSize: 8, color: '#9E9E9E', alignment: 'center' },
          { text: `Página ${currentPage} de ${pageCount}`, fontSize: 8, color: '#9E9E9E', alignment: 'right', margin: [0, 0, 40, 0] }
        ]
      }),
      styles: {
        subheader: { fontSize: 12, bold: true }
      }
    };

    // 3. Generación e Impresión del PDF
    if (win) {
      pdfMake.createPdf(docDefinition).print({}, win);
    } else {
      pdfMake.createPdf(docDefinition).print();
    }
  } catch (error) {
    if (win) win.close();
    throw error;
  }
}
